/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioCategory } from './';
import {
    PortfolioCategoryFromJSON,
    PortfolioCategoryFromJSONTyped,
    PortfolioCategoryToJSON,
} from './';
import type { PortfolioPeriod } from './';
import {
    PortfolioPeriodFromJSON,
    PortfolioPeriodFromJSONTyped,
    PortfolioPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemResource
 */
export interface PortfolioItemResource {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    description: string;
    /**
     * 
     * @type {PortfolioPeriod}
     * @memberof PortfolioItemResource
     */
    period?: PortfolioPeriod;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    thumbnail: string;
    /**
     * Content blocks stored as opaque JSON (e.g. TipTap document)
     * @type {object}
     * @memberof PortfolioItemResource
     */
    contentBlocks: object;
    /**
     * 
     * @type {number}
     * @memberof PortfolioItemResource
     */
    index: number;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioItemResource
     */
    published: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemResource
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemResource
     */
    industryExpertises?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioItemResource
     */
    postedOn?: Date;
    /**
     * 
     * @type {PortfolioCategory}
     * @memberof PortfolioItemResource
     */
    category?: PortfolioCategory;
    /**
     * ID of the linked profile experience, if any
     * @type {string}
     * @memberof PortfolioItemResource
     */
    experienceId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    freelancerFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    freelancerLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResource
     */
    freelancerAvatarUrl?: string;
}

/**
 * Check if a given object implements the PortfolioItemResource interface.
 */
export function instanceOfPortfolioItemResource(value: object): value is PortfolioItemResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('thumbnail' in value) || value['thumbnail'] === undefined) return false;
    if (!('contentBlocks' in value) || value['contentBlocks'] === undefined) return false;
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function PortfolioItemResourceFromJSON(json: any): PortfolioItemResource {
    return PortfolioItemResourceFromJSONTyped(json, false);
}

export function PortfolioItemResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'profileId': json['profileId'],
        'title': json['title'],
        'description': json['description'],
        'period': json['period'] == null ? undefined : PortfolioPeriodFromJSON(json['period']),
        'thumbnail': json['thumbnail'],
        'contentBlocks': json['contentBlocks'],
        'index': json['index'],
        'published': json['published'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'industryExpertises': json['industryExpertises'] == null ? undefined : json['industryExpertises'],
        'postedOn': json['postedOn'] == null ? undefined : (new Date(json['postedOn'])),
        'category': json['category'] == null ? undefined : PortfolioCategoryFromJSON(json['category']),
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
        'freelancerFirstName': json['freelancerFirstName'] == null ? undefined : json['freelancerFirstName'],
        'freelancerLastName': json['freelancerLastName'] == null ? undefined : json['freelancerLastName'],
        'freelancerAvatarUrl': json['freelancerAvatarUrl'] == null ? undefined : json['freelancerAvatarUrl'],
    };
}

export function PortfolioItemResourceToJSON(value?: PortfolioItemResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'profileId': value['profileId'],
        'title': value['title'],
        'description': value['description'],
        'period': PortfolioPeriodToJSON(value['period']),
        'thumbnail': value['thumbnail'],
        'contentBlocks': value['contentBlocks'],
        'index': value['index'],
        'published': value['published'],
        'tags': value['tags'],
        'industryExpertises': value['industryExpertises'],
        'postedOn': value['postedOn'] == null ? undefined : ((value['postedOn']).toISOString().substring(0,10)),
        'category': PortfolioCategoryToJSON(value['category']),
        'experienceId': value['experienceId'],
        'freelancerFirstName': value['freelancerFirstName'],
        'freelancerLastName': value['freelancerLastName'],
        'freelancerAvatarUrl': value['freelancerAvatarUrl'],
    };
}

